import React, { PureComponent } from 'react'
import Overlay, { StopPropagation } from '@ynap/overlay'
import { Portal } from 'react-portal'
import PropTypes from 'prop-types'
import { Button, SimpleAsyncButton } from '@ynap/button'
import BEMHelper from '@ynap/bem-helper'
import { ImageWithSkeleton } from '@ynap/image'
import { Link } from 'react-router-dom'
import track from 'react-tracking'
import { removeRestrictedItem, addRestrictedItemToWL, hazmatOverlayDisplayed } from './analytics/interactions'

const bem = new BEMHelper('CartRectifyOverlay')

@track()
class ShippingRestrictionsOverlay extends PureComponent {
    static propTypes = {
        soldoutItems: PropTypes.array,
        lineItems: PropTypes.array,
        title: PropTypes.string,
        clearRectification: PropTypes.func,
        messages: PropTypes.shape({
            cartRectification: PropTypes.shape({
                btn: PropTypes.func.isRequired,
                bagUpdated: PropTypes.func.isRequired,
                description: PropTypes.func.isRequired,
                title: PropTypes.func.isRequired
            })
        }),
        rectification: PropTypes.object,
        history: PropTypes.object.isRequired,
        setCheckoutNotification: PropTypes.object.isRequired,
        locale: PropTypes.shape({
            id: PropTypes.string.isRequired
        }),
        addItemsToWishlist: PropTypes.func.isRequired
    }

    state = {
        primaryLoading: false,
        wishlistLoading: false
    }
    @track(hazmatOverlayDisplayed)
    componentDidMount() {}

    removeItems = async () => {
        const { clearRectification, restrictedItems, removeLineItems, history, rectification, messages, setCheckoutNotification, locale } = this.props
        const { redirect = `/${locale.id}/checkout/shipping-options` } = rectification
        const removalPayload = restrictedItems.map(({ partNumber, orderItemId, quantity }) => {
            return { partNumber, orderItemId, quantity }
        })
        try {
            await removeLineItems(removalPayload)
            await clearRectification()
            setCheckoutNotification('info', messages.cartRectification.bagUpdated(), { autoHideDelay: 3000 })
            history.push(redirect)
        } catch (e) {
            /* @todo proper error handling - removed console log */
        }
    }

    @track(removeRestrictedItem)
    async handleClick() {
        this.setState({ primaryLoading: true })
        await this.removeItems()
        this.setState({ primaryLoading: false })
    }

    @track(addRestrictedItemToWL)
    async handleWishlistClick() {
        this.setState({ wishlistLoading: true })
        const { restrictedItems, addItemsToWishlist } = this.props
        const partNumbers = restrictedItems.map((product) => ({ partNumber: product.partNumber }))
        try {
            await addItemsToWishlist(partNumbers)
        } catch {}
        await this.removeItems()
        this.setState({ wishlistLoading: false })
    }

    onClose = () => {
        const { clearRectification } = this.props
        clearRectification()
    }

    render() {
        const { restrictedItems = [], messages, userStatus, locale, clearRectification } = this.props
        const { infoLink, title, description, primary, secondary } = messages.cartRectification.shippingRestricted
        const loggedIn = userStatus === 'R'
        return (
            <Portal>
                <Overlay title={title()} onClose={this.onClose} handleBodyClick={this.onClose} className={bem()}>
                    <StopPropagation>
                        <div className={bem('description')}>
                            {description()}
                            {infoLink ? (
                                <div className={bem('infoLink')}>
                                    <a target="_blank" href={`/${locale.id}${infoLink.url()}`}>
                                        {infoLink.text()}
                                    </a>
                                </div>
                            ) : null}
                        </div>

                        {loggedIn ? (
                            <SimpleAsyncButton
                                className={bem('addToWishlist')}
                                onClick={() => this.handleWishlistClick()}
                                type="secondary"
                                loading={this.state.wishlistLoading}
                                copy={messages.cartRectification.wishlist()}
                            />
                        ) : null}
                        <ul className={bem('productsContainer')}>
                            {restrictedItems.map((each) => {
                                const { partNumber, brand, name, image } = each
                                return (
                                    <li key={partNumber} className={bem('product')}>
                                        <div className={bem('imageContainer')}>
                                            <ImageWithSkeleton src={image?.url} imageSrcset={image?.srcSet}  alt={name} computeAttributes={false} />
                                        </div>
                                        <div className={bem('productDetails')}>
                                            <div className={bem('productDesigner')}>{brand}</div>
                                            <div className={bem('productName')}>{name}</div>
                                        </div>
                                    </li>
                                )
                            })}
                        </ul>
                        <div className={bem('buttonWrapper')}>
                            <SimpleAsyncButton
                                className={bem('button')}
                                onClick={() => this.handleClick()}
                                loading={this.state.primaryLoading}
                                type="primary"
                                copy={primary()}
                            />
                            <Button
                                component={Link}
                                className={bem('secondary')}
                                onClick={clearRectification}
                                to={`/${locale.id}/checkout/shipping-address`}
                                type="secondary"
                            >
                                {secondary()}
                            </Button>
                        </div>
                    </StopPropagation>
                </Overlay>
            </Portal>
        )
    }
}

export default ShippingRestrictionsOverlay
